import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Define translations directly
const enTranslation = {
  contactPage: {
    workingHours: "Opening Hours",
    mondayToSunday: "Monday - Sunday",
    workingHoursTime: "11:00 - 22:30",
    workingHoursDescription: "We're open every day to serve you with the best authentic Indian cuisine in Lagos."
  }
};

const ptTranslation = {
  contactPage: {
    workingHours: "Horário de Funcionamento",
    mondayToSunday: "Segunda - Domingo",
    workingHoursTime: "11:00 - 22:30",
    workingHoursDescription: "Estamos abertos todos os dias para o servir com a melhor cozinha indiana autêntica em Lagos."
  }
};

// Initialize i18next
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation
      },
      pt: {
        translation: ptTranslation
      }
    },
    lng: 'en', // Default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // React already escapes values
    }
  });

export default i18n; 